<ion-card>
  <ion-card-header>
    <ion-card-title>Kinevezések</ion-card-title>
    <ion-card-subtitle>
      A kinevezés fajtái és a kollégákhoz rendelésük. A tantárgyfelosztás ezekből számolja
      az óraszám-kedvezményt, ezért minden tanévre külön kell megadni őket.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="kin-fejlec">
      <ion-input label="Tanév (kezdő év)" label-placement="stacked" fill="outline" type="number"
                 [(ngModel)]="ev" (ionBlur)="betolt()"></ion-input>
      <ion-button fill="outline" (click)="atemeles()" [disabled]="fut">
        <ion-icon slot="start" name="copy-outline"></ion-icon>Átemelés előző tanévről
      </ion-button>
      <ion-button fill="outline" (click)="alapkeszletFelvesz()" [disabled]="fut">
        <ion-icon slot="start" name="list-outline"></ion-icon>Alapkészlet felvétele
      </ion-button>
    </div>

    <!-- Eltérés a kinevezés és az osztály osztályfőnöke között -->
    <div class="kin-elteres" *ngIf="!toltodik && vanEltere">
      <div class="fej"><ion-icon name="alert-circle-outline"></ion-icon> Eltérés az osztályfőnököknél</div>
      <div *ngIf="ellenorzes.osztaly_kinevezes_nelkul?.length">
        <b>Van osztályfőnöke, de nincs OF-kinevezése ebben a tanévben:</b>
        <span *ngFor="let o of ellenorzes.osztaly_kinevezes_nelkul; let last = last">
          {{ o.osztaly }} ({{ o.viselt_vez }} {{ o.viselt_ker }}){{ last ? '' : ', ' }}
        </span>
      </div>
      <div *ngIf="ellenorzes.kinevezes_osztaly_nelkul?.length">
        <b>Van OF-kinevezése, de egyetlen osztály sem az övé:</b>
        <span *ngFor="let k of ellenorzes.kinevezes_osztaly_nelkul; let last = last">
          {{ k.viselt_vez }} {{ k.viselt_ker }}{{ last ? '' : ', ' }}
        </span>
      </div>
      <ion-note color="medium">
        Az osztályfőnököt az Osztályok menüben tudod beállítani – ott a kinevezés is
        automatikusan létrejön, ha ebben a tanévben már van „OF" kódú kinevezés-fajta.
        A már beállított osztályfőnökök hiányzó kinevezését itt egyben pótolhatod.
      </ion-note>
      <ion-button size="small" color="warning" (click)="ofPotlas()"
                  [disabled]="fut || !ellenorzes.osztaly_kinevezes_nelkul?.length">
        <ion-icon slot="start" name="build-outline"></ion-icon>
        Hiányzó OF-kinevezések pótlása ({{ ellenorzes.osztaly_kinevezes_nelkul?.length || 0 }})
      </ion-button>
    </div>

    <div class="kin-allapot" *ngIf="toltodik">
      <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
    </div>

    <ng-container *ngIf="!toltodik">
      <h3>Kinevezés fajtái</h3>
      <div class="kin-tabla-burok">
        <table class="kin-tabla">
          <thead>
            <tr><th>Megnevezés</th><th>Kód</th><th class="szam">Órakedvezmény</th>
                <th class="szam">Hozzárendelve</th><th>Művelet</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of fajtak">
              <td>
                <span *ngIf="szerkesztett !== f.id">{{ f.nev }}</span>
                <ion-input *ngIf="szerkesztett === f.id" [(ngModel)]="f.nev" fill="outline"></ion-input>
              </td>
              <td>
                <span *ngIf="szerkesztett !== f.id" class="kod">{{ f.kod }}</span>
                <ion-input *ngIf="szerkesztett === f.id" [(ngModel)]="f.kod" fill="outline"></ion-input>
              </td>
              <td class="szam">
                <span *ngIf="szerkesztett !== f.id">{{ f.ora }} óra</span>
                <ion-input *ngIf="szerkesztett === f.id" type="number" [(ngModel)]="f.ora" fill="outline"></ion-input>
              </td>
              <td class="szam">{{ f.hozzarendelve }}</td>
              <td>
                <ion-button size="small" fill="clear" *ngIf="szerkesztett !== f.id"
                            (click)="szerkesztett = f.id">Szerkeszt</ion-button>
                <ion-button size="small" *ngIf="szerkesztett === f.id"
                            (click)="fajtaMentes(f)" [disabled]="fut">Mentés</ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="fajtaTorles(f)"
                            [disabled]="fut || f.hozzarendelve > 0"
                            [title]="f.hozzarendelve > 0 ? 'Előbb vedd le a kollégákról' : 'Törlés'">
                  Töröl
                </ion-button>
              </td>
            </tr>
            <tr *ngIf="!fajtak.length">
              <td colspan="5" class="ures">
                Ebben a tanévben még nincs kinevezés-fajta, ezért nincs mit szerkeszteni, és az
                osztályfőnöki kinevezések sem tudnak létrejönni. Emeld át az előző tanévről, vedd fel
                az <b>alapkészletet</b>, vagy adj hozzá egyedit alább – a felvett sorok itt bármikor
                szerkeszthetők és törölhetők.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="kin-uj">
        <ion-input label="Megnevezés" label-placement="stacked" fill="outline"
                   placeholder="pl. Munkaközösség-vezető" [(ngModel)]="ujFajta.nev"></ion-input>
        <ion-input label="Kód" label-placement="stacked" fill="outline"
                   placeholder="pl. MK" [(ngModel)]="ujFajta.kod"></ion-input>
        <ion-input label="Órakedvezmény" label-placement="stacked" fill="outline" type="number"
                   [(ngModel)]="ujFajta.ora"></ion-input>
        <ion-button (click)="fajtaFelvesz()" [disabled]="fut">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>Felvesz
        </ion-button>
      </div>

      <h3>Kollégák kinevezései</h3>
      <div class="kin-uj">
        <ion-input label="Kolléga keresése" label-placement="stacked" fill="outline"
                   placeholder="név vagy azonosító" [(ngModel)]="munkatarsSzuro">
          <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
        </ion-input>
        <ion-select label="Kolléga" label-placement="stacked" fill="outline" interface="popover"
                    [(ngModel)]="ujHozzarendeles.munkatars">
          <ion-select-option *ngFor="let m of szurtMunkatarsak" [value]="m.adid">
            {{ m.viselt_vez }} {{ m.viselt_ker }}
          </ion-select-option>
        </ion-select>
        <ion-select label="Kinevezés" label-placement="stacked" fill="outline" interface="popover"
                    [(ngModel)]="ujHozzarendeles.orakedvezmeny">
          <ion-select-option *ngFor="let f of fajtak" [value]="f.id">
            {{ f.nev }} ({{ f.kod }}, {{ f.ora }} óra)
          </ion-select-option>
        </ion-select>
        <ion-button (click)="hozzarendel()" [disabled]="fut">
          <ion-icon slot="start" name="person-add-outline"></ion-icon>Hozzárendel
        </ion-button>
      </div>

      <div class="kin-tabla-burok">
        <table class="kin-tabla">
          <thead>
            <tr><th>Kolléga</th><th>Kinevezései</th><th class="szam">Összes kedvezmény</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of kollegankent">
              <td>{{ k.nev }}</td>
              <td>
                <ion-chip *ngFor="let t of k.tetelek" outline (click)="hozzarendelesTorles(t)"
                          [title]="'Kattints a visszavonáshoz'">
                  <ion-label>{{ t.nev }} ({{ t.kod }})</ion-label>
                  <ion-icon name="close-circle"></ion-icon>
                </ion-chip>
              </td>
              <td class="szam">{{ k.ossz_ora }} óra</td>
            </tr>
            <tr *ngIf="!kollegankent.length">
              <td colspan="3" class="ures">Ebben a tanévben még senkinek nincs kinevezése.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
